import React from 'react';
import './styles.css';
import Loader from '../../assets/animations/Loader';
import GearAnimation from '../../assets/animations/Gear';
import DesktopAnimation from '../../assets/animations/Desktop';
import EducationCard from '../../components/EducationCard';
const Fade = require('react-reveal/Fade');
const Zoom = require('react-reveal/Zoom');

export default function WhoAmIPage() {


    return(
        <>
            <div id="who-am-i-page">
                <main>
                    <Loader/>
                    <div>                    
                        <Fade left><h1>F U L L - S T A C K</h1></Fade>
                    </div>
                    <div>
                        <Fade top>
                            <h1>B</h1>
                            <br/>
                            <h1>R</h1>
                            <br/>
                            <h1>I</h1>
                            <br/>
                            <h1>A</h1>
                            <br/>
                            <h1>N</h1>
                        </Fade>
                        <br/>
                        <br/>
                        <br/>
                        <Fade bottom>
                            <h1>M</h1>
                            <br/>
                            <h1>E</h1>
                            <br/>
                            <h1>L</h1>
                            <br/>
                            <h1>L</h1>
                            <br/>
                            <h1>O</h1>
                        </Fade>
                    </div>
                    <div>
                        <Fade right><h1>D E V E L O P E R</h1></Fade>
                    </div>
                </main>
            </div>
            <div id="about-me">
                <Fade left>
                    <div className="my-photo">
                        <img src="https://avatars1.githubusercontent.com/u/35143307?s=460&u=4caac707a8eb1f7c7a70bbe0f9d35caef4f4a689&v=4" alt="Brian Mello"/>
                    </div>
                </Fade>
                <Fade right>
                    <div className="my-informations">
                        <legend>Sobre mim</legend>
                        <p>Sou apaixonado por tecnologia desde pequeno. Por conta disso, cursei Análise e desenvolvimento de sistemas na 
                            Unicesumar onde adquiri diversas experiências tanto com conceitos práticos quanto técnicos sobre softwares,  
                            hardwares, redes, metodologias ágeis. Desenvolvi alguns projetos utilizando linguagens como Java, C e C++. Além disso, no 
                            tempo que cursei a faculdade, aproveitei para fazer em paralelo, um Bootcamp de Desenvolvimento Web 
                            FullStack na Labenu, pois eu queria ampliar os meus conhecimentos nessa área. 
                            Nos 6 meses que cursei o Bootcamp eu adquiri diversos conceitos técnicos e práticos tanto sobre 
                            desenvolvimento quanto sobre o mundo de trabalho na área de tecnologia. Lá criei sites utilizando tecnologias 
                            como HTML, CSS, Javascript, ReactJs, Redux, NodeJs, Typescript, AWS, etc. 
                            Desenvolvi projetos em equipe que agregaram bastante conhecimento tanto em sentido profissional quanto pessoal. 
                        </p>
                        <p>Em Resumo, Eu amo aprender e trocar experiências com as pessoas ao meu redor pois 
                            acredito que só assim podemos mudar o mundo.
                        </p>
                        <div className="skills">
                            <span>NodeJs</span>
                            <span>MySQL</span>
                            <span>HTML</span>
                            <span>CSS</span>
                            <span>JavaScript</span>
                            <span>Typescript</span>
                        </div>
                        <button>
                            <a 
                                href="https://drive.google.com/file/d/1iRClxKclLVYz_K9Fknhoon7LBdVIx6sr/view?usp=sharing"
                                target="blank"
                            >
                                CV em PDF
                            </a>
                        </button>
                    </div>
                </Fade>
            </div>
            <div id="what-i-do">
                <legend>O que eu faço?</legend>
                <Fade left>
                    <div className="stack">
                        <div className="text">
                            <h2>F r o n t - e n d</h2>
                            <p>Desenvolvimento de aplicações web utilizando HTML, CSS, JavaScript e Typescript.</p>
                            <li>Sites Reponsivos seguindo os princípios de mobile first.</li>
                            <li>Animações para trazer mais vida para as aplicações web.</li>
                            <li>Arquitetura do código seguindo os principios S.O.L.I.D.</li>
                            <li>Deploy de aplicações utilizando plataformas como firebase, AWS, github pages, netlify, entre outros.</li>
                        </div>
                        <DesktopAnimation/>
                    </div>
                </Fade>
                <Fade right>
                    <div className="stack">
                        <GearAnimation/>
                        <div className="text">
                            <h2>B a c k - e n d</h2>
                            <p>Desenvolvimento de Aplicações utilizando NodeJs, Typescript, PostgreSQL, MySQL e MongoDB.</p>
                            <li>Criação de APIs para comunicação com o Front-end seguindos os princípios de clean-code.</li>
                            <li>Deploy da APIs utilizando serviços como Firebase e AWS.</li>
                            <li>Documentações bem escritas utilizando Github, Postman e insomnia.</li>
                        </div>
                    </div>
                </Fade>
            </div>
            <div id="my-education">
                <legend>Educação</legend>
                <div className="cards">
                    <Fade left>
                        <EducationCard 
                            institution="Labenu: Curso de Web Full Stack" 
                            time="2019 - 2020: 6 meses" 
                            description="Experiência de 1000 horas de aprendizagem em Front-End, Back-End e DevOps, cobrindo os seguintes tópicos, ferramentas e frameworks: Javascript; HTML; CSS; SQL; Git; AWS; Node.js; React.js; Github; Typescript; Unit Testing; Firebase; Clean Architecture."
                        />
                    </Fade>
                    <Zoom>
                        <EducationCard 
                            institution="Unicesumar: Análise e Dese- nvolvimento de Sistemas" 
                            time="2017 - 2020: 3 anos" 
                            description="Experiência de 2300 horas em Desenvolvimento, metodologias ágeis, redes, etc. participei do Laboratório de Arquitetura e 
                            Redes de Computadores e fiz projetos de iniciação científica. Fui melhor aluno da turma em matérias como Banco de dados, Engenharia de Software, Formação Sociocultural e ética, entre outras."
                        />
                    </Zoom>
                    <Fade right>
                        <EducationCard 
                            institution="Rocketseat: Curso de Desenvolvimento Mobile" 
                            time="2020 - 2020: 70 horas" 
                            description="Experiência de 70 horas em Desenvolvimento mobile. Aprendi muitas coisas, dentre elas aprendi sobre a componenti- zação em react native, web viewers e muito mais. Fiz um projeto baseado no instagram."
                        />
                    </Fade>
                </div>
            </div>
        </>
    )
};